<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="mechanism" label-width="80px" class="unitWidth"
                     size="small">
                <el-form-item label="所属工厂">
                    <el-select v-model="mechanism.fcCode" placeholder="请选择" :clearable="isclear" :disabled="ischeck"
                               filterable @change="fcChange">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.value"
                            :label="factory.label"
                            :value="factory.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="mechanism.shopCode" placeholder="请选择" clearable filterable @change="shopChange"
                    >
                        <el-option
                            v-for="shop in shopList"
                            :key="shop.value"
                            :label="shop.label"
                            :value="shop.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="mechanism.sectionCode" placeholder="请选择" clearable filterable
                               @change="sectionChange"
                    >
                        <el-option
                            v-for="section in sectionList"
                            :key="section.value"
                            :label="section.label"
                            :value="section.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="mechanism.lineCode" placeholder="请选择" clearable filterable @change="lineChange">
                        <el-option
                            v-for="line in lineList"
                            :key="line.value"
                            :label="line.label"
                            :value="line.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备编号">
                    <el-input v-model.trim="searchParams.devCode" placeholder="设备编号"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="searchParams.detectnResult" placeholder="请选择" clearable filterable>
                        <el-option label="未检测" value="notCheck"/>
                        <el-option label="正常" value="normal"/>
                        <el-option label="异常" value="abnormal"/>
                        <el-option label="制定改善计划" value="correctPlan"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否完成">
                    <el-select v-model="searchParams.isComplete" placeholder="请选择" clearable filterable>
                        <el-option label="完成" :value="1"/>
                        <el-option label="未完成" :value="0"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="计划时间">
                    <el-date-picker
                        v-model="searchParams.planTime"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item style="margin-left: 20px;">
                    <el-button type="primary" @click="detectnOrderPage">查询</el-button>
                    <el-button size="small" type="success" @click="addDetectOrder()" v-for="acc in access"
                               v-if="acc=='NL0005'">新增
                    </el-button>
                </el-form-item>
            </el-form>
        </SearchBox>

        <LabelContent title="能力检测工单列表" ref="LabelContent">
            <!-- <div slot="btns">
                <el-button size="small" type="success" @click="exportShift">导出</el-button>
            </div> -->
        </LabelContent>
        <div class="tableBox">
            <el-table stripe :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="deptName" label="所属组织" width="249px"/>
                <el-table-column prop="adoCode" label="检测工单号" show-overflow-tooltip/>
                <el-table-column prop="devCode" label="设备编号" show-overflow-tooltip/>
                <el-table-column prop="devName" label="设备名称" show-overflow-tooltip/>
                <el-table-column prop="planTime" label="计划时间" show-overflow-tooltip/>
                <el-table-column prop="planUserName" label="计划人" show-overflow-tooltip/>
                <el-table-column prop="detectnResult" label="状态" show-overflow-tooltip/>
                <el-table-column prop="actionUserName" label="实际执行人" show-overflow-tooltip/>
                <el-table-column label="是否完成" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.isComplete == 1">已完成</span>
                        <span v-if="scope.row.isComplete == 0">未完成</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <i class="editBtn iconfont u-youjianbianji" @click="orderDetail(scope.row)"
                           v-for="acc in access" v-if="acc=='NL0007'"/>
                        <i class="delBtn iconfont u-shanchu" @click="deleteOrder(scope.row)" v-for="acc in access"
                           v-if="acc=='NL0006'"/>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.pageNumber"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.total"
            />
        </div>
        <el-dialog title="新增" width="500px" :visible.sync="addShow" style="text-align:left">
            <el-form :model="addForm" :rules="rules" ref="rules" label-width="100px" class="demo-roleForm">
                <el-form-item label="设备编号" prop="devCode">
                    <el-select v-model="addForm.devCode" placeholder="请选择设备编号" clearable filterable>
                        <el-option v-for="dev in deviceInfoList" :key="dev.devId" :label="dev.devCode" :value="dev.devCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工单执行人" prop="actionUser">
                    <el-select v-model="addForm.actionUser" placeholder="请选择" clearable filterable>
                        <el-option
                            v-for="user in userList"
                            :key="user.userId"
                            :label="user.userName"
                            :value="user.userAccount">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计划时间" prop="planTime">
                    <el-date-picker
                        v-model="addForm.planTime"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addShow = false">取 消</el-button>
                <el-button type="primary" @click="addDetectnOrder('rules')">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import DetectnOrder from '../../../api/detectnorder.js'

    export default {
        name: 'abilityDetectnOrderList',
        data() {
            return {
                mechanism: {
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: ''
                },
                searchParams: {
                    pageSize: 10,
                    pageNumber: 1,
                    total: 0,
                    fcCode: '',
                    shopCode: '',
                    vsmCode: '',
                    lineCode: '',
                    planTime: '',
                    devCode: '',
                    detectnResult: '',
                    isComplete: '',
                    planTime: ''
                },
                factoryTree: [],
                addShow: false,
                userInfo: {},
                fcIdSelected: '',
                tableData: [],
                addForm: {
                    devCode: '',
                    planTime: '',
                    actionUser: ''

                },
                rules: {
                    devCode: [
                        {
                            required: true,
                            message: '请输入设备编号',
                            trigger: 'change'
                        }
                    ],
                    actionUser: [
                        {
                            required: true,
                            message: '请选择工单执行人',
                            trigger: 'change'
                        }
                    ],
                    planTime: [
                        {
                            required: true,
                            message: '请输入计划时间',
                            trigger: 'blur'
                        }
                    ]
                },
                factoryData: [],
                access: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                isclear: false,
                userList: [],
                deviceInfoList: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode.length > 0) {
                    var factory = JSON.parse(this.mechanism.fcCode)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.mechanism.shopCode != undefined && this.mechanism.shopCode.length > 0) {
                    var shop = JSON.parse(this.mechanism.shopCode)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.mechanism.sectionCode != undefined && this.mechanism.sectionCode.length > 0) {
                    var vsm = JSON.parse(this.mechanism.sectionCode)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
            // this.getFactory()
        },
        methods: {
            init() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getData()
            },
            addDetectOrder() {
                if (this.mechanism.fcCode == undefined || this.mechanism.fcCode == '') {
                    this.$message.error('请选择工厂！')
                    return
                }
                this.addShow = true
            },
            getUser() {
                let params = {}
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode != '') {
                    params['fcCode'] = JSON.parse(this.mechanism.fcCode).deptCode
                } else {
                    return
                }
                let options = {
                    method: 'get',
                    url: this.$api.userList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.userList = response.data
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            getDeviceInfoList() {
                let queryParams = {}
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode != '') {
                    queryParams['fcCode'] = JSON.parse(this.mechanism.fcCode).deptCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.deviceInfoList,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.deviceInfoList = response.data
                    }
                })
            },
            orderDetail(order) {
                console.log('-------' + JSON.stringify(order))
                this.$router.push({
                    path: '/abilityDetectnOrderInfo',
                    query: {
                        order: JSON.stringify(order)
                    }
                })
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.detectnOrderPage()
            },
            paginationCurrentChange(val) {
                this.searchParams.pageNumber = val
                this.detectnOrderPage()
            },
            fcChange() {
                this.mechanism.shopCode = ''
                this.mechanism.vsmCode = ''
                this.mechanism.lineCode = ''
                this.detectnOrderPage()
                this.getUser()
                this.getDeviceInfoList()
            },
            shopChange() {
                this.mechanism.vsmCode = ''
                this.mechanism.lineCode = ''
                this.detectnOrderPage()
            },
            sectionChange() {
                this.mechanism.lineCode = ''
                this.detectnOrderPage()
            },
            lineChange() {
                this.detectnOrderPage()
            },
            addDetectnOrder(rules) {
                this.$refs[rules].validate((valid) => {
                    if (valid) {
                        let self = this
                        self.addForm.planTime = self.$moment(self.addForm.planTime).format('YYYY-MM-DD HH:mm:ss')
                        let options = {
                            method: 'POST',
                            url: DetectnOrder.addAbilityDetectnOrder,
                            params: self.addForm
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                self.$message.success('添加计划成功')
                                self.detectnOrderPage()
                                self.addShow = false
                            } else {
                                self.$message.error(response.message)
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
            deleteOrder(row) {
                var self = this
                let params = {
                    adoCode: row.adoCode
                }
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let options = {
                        method: 'POST',
                        url: DetectnOrder.deleteAbilityDetectnOrder,
                        params: params
                    }
                    this.$http.request(options).then(response => {
                        if (response.status == 100) {
                            self.$message.success('删除成功!')
                            self.detectnOrderPage()
                        } else {
                            self.$message.error('删除失败!')
                        }
                    })
                        .catch(err => {
                            this.detectnOrderPage()
                            // this.$message.error(err);
                        })
                })
                    .catch(() => {
                        this.detectnOrderPage()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            detectnOrderPage() {
                var self = this
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    self.searchParams.fcCode = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    self.searchParams.shopCode = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode && self.mechanism.sectionCode != '') {
                    self.searchParams.vsmCode = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    self.searchParams.lineCode = JSON.parse(self.mechanism.lineCode).deptCode
                }
                let options = {
                    method: 'get',
                    url: DetectnOrder.getAllAbilityDetectnOrder,
                    params: self.searchParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.tableData = response.data.list
                        self.searchParams.total = response.data.total
                    }
                })
            },
            getFactory() {
                let queryParams = {
                    fcCode: this.userInfo.fcCode
                }
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryData = response.data
                    }
                })
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.mechanism.fcCode = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    this.detectnOrderPage()
                    this.getUser()
                    this.getDeviceInfoList()
                })
            }
        }
    }
</script>

<style scoped>

</style>
